import '@/src/imports'
// import { useLogError } from '../common/hooks/useLogError'
// import { useEffect } from 'react'
import { DesignSystem } from '@/src/design-system'

export default function NotFoundScreen() {
  // const logError = useLogError()

  // useEffect(() => {
  //   logError('User Navigated To Undefined Navigational Route')
  // }, [logError])

  return <DesignSystem.Loading.Screen />
}
